import { render, staticRenderFns } from "./ToggleControl.vue?vue&type=template&id=be9c7ffc&scoped=true"
import script from "./ToggleControl.vue?vue&type=script&lang=js"
export * from "./ToggleControl.vue?vue&type=script&lang=js"
import style0 from "./ToggleControl.vue?vue&type=style&index=0&id=be9c7ffc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9c7ffc",
  null
  
)

export default component.exports